var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolcano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8863_29",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8863_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3499 22.5H5.07487C4.34153 22.5 3.77903 22.2 3.38737 21.6C2.9957 21 2.94987 20.3667 3.24987 19.7L5.47487 14.7C5.64154 14.3333 5.88737 14.0417 6.21237 13.825C6.53737 13.6083 6.89987 13.5 7.29987 13.5H8.99987L10.4999 9.75C10.6499 9.36667 10.8915 9.0625 11.2249 8.8375C11.5582 8.6125 11.9332 8.5 12.3499 8.5H16.4999C16.9499 8.5 17.3499 8.63333 17.6999 8.9C18.0499 9.16667 18.2915 9.51667 18.4249 9.95L21.2749 19.95C21.4582 20.5833 21.3499 21.1667 20.9499 21.7C20.5499 22.2333 20.0165 22.5 19.3499 22.5ZM12.9999 4.5V2.5C12.9999 2.21667 13.0957 1.97917 13.2874 1.7875C13.479 1.59583 13.7165 1.5 13.9999 1.5C14.2832 1.5 14.5207 1.59583 14.7124 1.7875C14.904 1.97917 14.9999 2.21667 14.9999 2.5V4.5C14.9999 4.78333 14.904 5.02083 14.7124 5.2125C14.5207 5.40417 14.2832 5.5 13.9999 5.5C13.7165 5.5 13.479 5.40417 13.2874 5.2125C13.0957 5.02083 12.9999 4.78333 12.9999 4.5ZM16.8249 5.275L18.2499 3.85C18.4332 3.66667 18.6624 3.575 18.9374 3.575C19.2124 3.575 19.4499 3.66667 19.6499 3.85C19.8499 4.05 19.9499 4.28333 19.9499 4.55C19.9499 4.81667 19.8499 5.05 19.6499 5.25L18.2249 6.675C18.0415 6.85833 17.8124 6.95417 17.5374 6.9625C17.2624 6.97083 17.0249 6.875 16.8249 6.675C16.6415 6.49167 16.5499 6.25833 16.5499 5.975C16.5499 5.69167 16.6415 5.45833 16.8249 5.275ZM9.77487 6.675L8.34987 5.25C8.16653 5.06667 8.07487 4.8375 8.07487 4.5625C8.07487 4.2875 8.16653 4.05 8.34987 3.85C8.54987 3.65 8.7832 3.55 9.04987 3.55C9.31654 3.55 9.54987 3.65 9.74987 3.85L11.1749 5.275C11.3582 5.45833 11.454 5.6875 11.4624 5.9625C11.4707 6.2375 11.3749 6.475 11.1749 6.675C10.9915 6.85833 10.7582 6.95 10.4749 6.95C10.1915 6.95 9.9582 6.85833 9.77487 6.675Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcano);
export default __webpack_public_path__ + "static/media/volcano.6242066f9380ea2c2b1be4a7d610afdd.svg";
export { ForwardRef as ReactComponent };